/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}    from '@/models/action';
import {Logger}                from '@/util/logger';
import {JSONBrowserMetadata}   from '@/screens/ide/json.browser.metadata';
import {WindowService}         from "@/services/window.service";

/**
 *
 * @class JSONEditAction
 *
 * @brief launch a fresh (JSON) editor tab
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class JSONEditAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.jsonedit',
      type:  ActionType.Window_JSONEdit,
      label: 'JSON Edit (Empty)',
      icon:  '<i class="fas fa-edit"></i>',
      tip:   'Launch a JSON editor'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[JSONEditAction] executing...');

    this.windows.launchWindow(new JSONBrowserMetadata(
      '',
      '',
      '',
      'json',
      '',
      '<i class="fas fa-edit"></i>'
    ));

    return true;
  }
}
